import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { Partner } from '../../models/partners/partners.model';

@Component({
    selector: 'swb-partner-list',
    templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class PartnerListComponent extends ListBase<Partner> {
    public url = 'partners';
    public routePrefix = 'partners';

    protected hasPagination = false;

    constructor(
        _apiService: ApiService,
        _communicationService: CommunicationService
    ) {
        super(
            _apiService,
            _communicationService
        );
    }
}
